import packageJson from "../../package.json";

export const env = {
    production: false,
    appVersion: packageJson.version
};